/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { Icon } from '@az/starc-ui';
import { Play } from '@az/starc-ui-icons';
import styles from './styles.module.scss';

type PlayButtonProps = {
  size?: number;
};

export const PlayButton = ({ size = 3.5 }: PlayButtonProps) => (
  <div
    className={styles.playButton}
    style={{ '--play-button-size-factor': size * 2 } as React.CSSProperties}
  >
    <Icon svg={Play} size={size} />
  </div>
);
